<template>
    <div class="kenoWrapper">
    <div class="module kenoDrawings" id="kenoLive">
        <div id="kenoPlayer">
            <img src="/getattachment/b2e7fd78-3005-4c74-b151-b08541605c30/829_GameLogo.png" id="KENOlogo" alt="KENO" />
            <div id="kenoPlayerIntro">
                <h1>Latest Keno Drawings</h1>
                <button class="drawStart button btn-tertiary" type="button">Watch the Latest Draw</button>
            </div>
            <div id="kenoPlayerClose">
                <button class="drawStart button btn-tertiary" type="button">WATCH THE LATEST DRAW</button>
                <!-- Need help? <a href="">Click here</a> -->
            </div>
            <div id="kenoComingUp">
                <h2>COMING UP...</h2>
                DRAWING # <span class="kenoDrawNumber">0000000</span>
            </div>
            <div id="kenoDrawLbl">
                Draw # <span class="kenoDrawNumber">0000000</span>
            </div>
            <div id="kenoBoosterLbl">
                <span id="boosterVal">0</span>X Booster<span class="tm">&reg;</span>
            </div>
            <div id="drawingError"></div>
            <div id="kenoGrid">
                <span class="kenoNumber" id="ball1">1</span>
                <span class="kenoNumber" id="ball2">2</span>
                <span class="kenoNumber" id="ball3">3</span>
                <span class="kenoNumber" id="ball4">4</span>
                <span class="kenoNumber" id="ball5">5</span>
                <span class="kenoNumber" id="ball6">6</span>
                <span class="kenoNumber" id="ball7">7</span>
                <span class="kenoNumber" id="ball8">8</span>
                <span class="kenoNumber" id="ball9">9</span>
                <span class="kenoNumber" id="ball10">10</span>
                <span class="kenoNumber" id="ball11">11</span>
                <span class="kenoNumber" id="ball12">12</span>
                <span class="kenoNumber" id="ball13">13</span>
                <span class="kenoNumber" id="ball14">14</span>
                <span class="kenoNumber" id="ball15">15</span>
                <span class="kenoNumber" id="ball16">16</span>
                <span class="kenoNumber" id="ball17">17</span>
                <span class="kenoNumber" id="ball18">18</span>
                <span class="kenoNumber" id="ball19">19</span>
                <span class="kenoNumber" id="ball20">20</span>
                <span class="kenoNumber" id="ball21">21</span>
                <span class="kenoNumber" id="ball22">22</span>
                <span class="kenoNumber" id="ball23">23</span>
                <span class="kenoNumber" id="ball24">24</span>
                <span class="kenoNumber" id="ball25">25</span>
                <span class="kenoNumber" id="ball26">26</span>
                <span class="kenoNumber" id="ball27">27</span>
                <span class="kenoNumber" id="ball28">28</span>
                <span class="kenoNumber" id="ball29">29</span>
                <span class="kenoNumber" id="ball30">30</span>
                <span class="kenoNumber" id="ball31">31</span>
                <span class="kenoNumber" id="ball32">32</span>
                <span class="kenoNumber" id="ball33">33</span>
                <span class="kenoNumber" id="ball34">34</span>
                <span class="kenoNumber" id="ball35">35</span>
                <span class="kenoNumber" id="ball36">36</span>
                <span class="kenoNumber" id="ball37">37</span>
                <span class="kenoNumber" id="ball38">38</span>
                <span class="kenoNumber" id="ball39">39</span>
                <span class="kenoNumber" id="ball40">40</span>
                <span class="kenoNumber" id="ball41">41</span>
                <span class="kenoNumber" id="ball42">42</span>
                <span class="kenoNumber" id="ball43">43</span>
                <span class="kenoNumber" id="ball44">44</span>
                <span class="kenoNumber" id="ball45">45</span>
                <span class="kenoNumber" id="ball46">46</span>
                <span class="kenoNumber" id="ball47">47</span>
                <span class="kenoNumber" id="ball48">48</span>
                <span class="kenoNumber" id="ball49">49</span>
                <span class="kenoNumber" id="ball50">50</span>
                <span class="kenoNumber" id="ball51">51</span>
                <span class="kenoNumber" id="ball52">52</span>
                <span class="kenoNumber" id="ball53">53</span>
                <span class="kenoNumber" id="ball54">54</span>
                <span class="kenoNumber" id="ball55">55</span>
                <span class="kenoNumber" id="ball56">56</span>
                <span class="kenoNumber" id="ball57">57</span>
                <span class="kenoNumber" id="ball58">58</span>
                <span class="kenoNumber" id="ball59">59</span>
                <span class="kenoNumber" id="ball60">60</span>
                <span class="kenoNumber" id="ball61">61</span>
                <span class="kenoNumber" id="ball62">62</span>
                <span class="kenoNumber" id="ball63">63</span>
                <span class="kenoNumber" id="ball64">64</span>
                <span class="kenoNumber" id="ball65">65</span>
                <span class="kenoNumber" id="ball66">66</span>
                <span class="kenoNumber" id="ball67">67</span>
                <span class="kenoNumber" id="ball68">68</span>
                <span class="kenoNumber" id="ball69">69</span>
                <span class="kenoNumber" id="ball70">70</span>
                <span class="kenoNumber" id="ball71">71</span>
                <span class="kenoNumber" id="ball72">72</span>
                <span class="kenoNumber" id="ball73">73</span>
                <span class="kenoNumber" id="ball74">74</span>
                <span class="kenoNumber" id="ball75">75</span>
                <span class="kenoNumber" id="ball76">76</span>
                <span class="kenoNumber" id="ball77">77</span>
                <span class="kenoNumber" id="ball78">78</span>
                <span class="kenoNumber" id="ball79">79</span>
                <span class="kenoNumber" id="ball80">80</span>
            </div>
            <div id="kenoWinningGrid"> </div>
            <div id="kenoPlayerFooter">
                <ul id="kenoControls">
                    <li class="kenoCtrlPlay">
                        <a class="btnKenoPlay">Play/Pause</a>
                    </li>
                    <li class="kenoCtrlResults">
                        <a class="btnKenoResults">SKIP TO RESULTS</a>
                    </li>
                    <li class="kenoCtrlSkip">
                        <a href="#prev" class="btnKenoPrev">prev</a> |
                        <a href="#next" class="btnKenoNext">next</a>
                    </li>
                </ul>
                <h4 class="themeHdr" id="themeHdr">To watch a specific drawing:</h4>
                <div id="kenoThemes">
                    <p class="themeInfo">Choose a theme:</p>
                    <ul id="themeOptions">
                        <li class="themeOption">
                            <a href="#" id="general" class="themeOptionLink themeGeneric themeActive ir">Classic
                                KENO</a>
                        </li>
                        <li class="themeOption">
                            <a href="#" id="blackjack" class="themeOptionLink themeBlackJack ir">Blackjack</a>
                        </li>
                        <li class="themeOption">
                            <a href="#" id="baseball" class="themeOptionLink themeBaseball ir">Baseball</a>
                        </li>
                    </ul>
                </div>
                <div id="kenoSpecificDraw" class="cf">
                    <div class="kenoSpecificNumber">
                        <label>Enter Draw Number:</label>
                        <input v-model="drawNumber" type="text" id="drawNumber" maxlength="8" />
                        <span v-if="seqErrors.length" class="numberError">
                            <ul>
                                <li v-for="error in seqErrors" v-bind:key="error">{{ error }}</li>
                            </ul>
                        </span>
                    </div>
                    <div class="kenoSpecificQuant">
                        <label>Consecutive draws you want to see:</label>
                        <select id="drawQuantity" v-model="drawQuantity">
                            <option value="1">One Draw</option>
                            <option value="2">Two Draws</option>
                            <option value="3">Three Draws</option>
                            <option value="4">Four Draws</option>
                            <option value="5">Five Draws</option>
                            <option value="10">Ten Draws</option>
                            <option value="20">Twenty Draws</option>
                        </select>
                    </div>
                    <button type="button" id="kenoSpecificSubmit"
                        class="btnMobileLarge button kenoSpecificSubmit">GO</button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
// import jQuery
import $ from 'jquery';

export default {
    components: {

    },
    data: function () {
        return {
            seqErrors: [],
            drawNumber: null,
            drawQuantity: 1,
            multiDraw: false,
            quickDrawNumber: null,
            quickErrors: [],
            apiToken: null,
            drawData: {},
        }
    },
    mounted: function () {
        this.getAPItoken()
            .then((token) => {
                this.apiToken = token;
                this._kenoPlayer();
            });
    },
    methods: {
        // jQuery functions ported over from old site
        _kenoPlayer() {
            let _this = this;
            /* jQuery css bezier animation support -- Jonah Fox - version 0.0.1 * Released under the MIT license.
                var path = $.path.bezier({
                    start: {x:10, y:10, angle: 20, length: 0.3},
                    end: {x:20, y:30, angle: -20, length: 0.2}
                })
                $("myobj").animate({path: path}, duration)
            */
            (function ($) { $.path = {}; var V = { rotate: function (p, degrees) { var radians = degrees * 3.141592654 / 180; var c = Math.cos(radians), s = Math.sin(radians); return [c * p[0] - s * p[1], s * p[0] + c * p[1]]; }, scale: function (p, n) { return [n * p[0], n * p[1]] }, add: function (a, b) { return [a[0] + b[0], a[1] + b[1]] }, minus: function (a, b) { return [a[0] - b[0], a[1] - b[1]] } }; $.path.bezier = function (params) { params.start = $.extend({ angle: 0, length: 0.3333 }, params.start); params.end = $.extend({ angle: 0, length: 0.3333 }, params.end); this.p1 = [params.start.x, params.start.y]; this.p4 = [params.end.x, params.end.y]; var v14 = V.minus(this.p4, this.p1); var v12 = V.scale(v14, params.start.length); v12 = V.rotate(v12, params.start.angle); this.p2 = V.add(this.p1, v12); var v41 = V.scale(v14, -1); var v43 = V.scale(v41, params.end.length); v43 = V.rotate(v43, params.end.angle); this.p3 = V.add(this.p4, v43); this.f1 = function (t) { return (t * t * t); }; this.f2 = function (t) { return (3 * t * t * (1 - t)); }; this.f3 = function (t) { return (3 * t * (1 - t) * (1 - t)); }; this.f4 = function (t) { return ((1 - t) * (1 - t) * (1 - t)); }; this.css = function (p) { var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4 = this.f4(p); var x = this.p1[0] * f1 + this.p2[0] * f2 + this.p3[0] * f3 + this.p4[0] * f4; var y = this.p1[1] * f1 + this.p2[1] * f2 + this.p3[1] * f3 + this.p4[1] * f4; return { top: y + "px", left: x + "px" }; }; }; $.path.arc = function (params) { for (var i in params) { this[i] = params[i] }; this.dir = this.dir || 1; while (this.start > this.end && this.dir > 0) { this.start -= 360 }; while (this.start < this.end && this.dir < 0) { this.start += 360 }; this.css = function (p) { var a = this.start * (p) + this.end * (1 - (p)); a = a * 3.1415927 / 180; var x = Math.sin(a) * this.radius + this.center[0]; var y = Math.cos(a) * this.radius + this.center[1]; return { top: y + "px", left: x + "px" }; } }; $.fx.step.path = function (fx) { var css = fx.end.css(1 - fx.pos); for (var i in css) { fx.elem.style[i] = css[i]; } } })(jQuery);

            var path = {};
            var V = {
                rotate: function (p, degrees) {
                    var radians = degrees * 3.141592654 / 180;
                    var c = Math.cos(radians),
                        s = Math.sin(radians);
                    return [c * p[0] - s * p[1], s * p[0] + c * p[1]];
                },
                scale: function (p, n) {
                    return [n * p[0], n * p[1]]
                },
                add: function (a, b) {
                    return [a[0] + b[0], a[1] + b[1]]
                },
                minus: function (a, b) {
                    return [a[0] - b[0], a[1] - b[1]]
                }
            };
            path.bezier = function (params) {
                params.start = $.extend({
                    angle: 0,
                    length: 0.3333
                }, params.start);
                params.end = $.extend({
                    angle: 0,
                    length: 0.3333
                }, params.end);
                this.p1 = [params.start.x, params.start.y];
                this.p4 = [params.end.x, params.end.y];
                var v14 = V.minus(this.p4, this.p1);
                var v12 = V.scale(v14, params.start.length);
                v12 = V.rotate(v12, params.start.angle);
                this.p2 = V.add(this.p1, v12);
                var v41 = V.scale(v14, -1);
                var v43 = V.scale(v41, params.end.length);
                v43 = V.rotate(v43, params.end.angle);
                this.p3 = V.add(this.p4, v43);
                this.f1 = function (t) {
                    return (t * t * t);
                };
                this.f2 = function (t) {
                    return (3 * t * t * (1 - t));
                };
                this.f3 = function (t) {
                    return (3 * t * (1 - t) * (1 - t));
                };
                this.f4 = function (t) {
                    return ((1 - t) * (1 - t) * (1 - t));
                };
                this.css = function (p) {
                    var f1 = this.f1(p),
                        f2 = this.f2(p),
                        f3 = this.f3(p),
                        f4 = this.f4(p);
                    var x = this.p1[0] * f1 + this.p2[0] * f2 + this.p3[0] * f3 + this.p4[0] * f4;
                    var y = this.p1[1] * f1 + this.p2[1] * f2 + this.p3[1] * f3 + this.p4[1] * f4;
                    return {
                        top: y + "px",
                        left: x + "px"
                    };
                };
            };
            path.arc = function (params) {
                for (var i in params) {
                    this[i] = params[i]
                };
                this.dir = this.dir || 1;
                while (this.start > this.end && this.dir > 0) {
                    this.start -= 360
                };
                while (this.start < this.end && this.dir < 0) {
                    this.start += 360
                };
                this.css = function (p) {
                    var a = this.start * (p) + this.end * (1 - (p));
                    a = a * 3.1415927 / 180;
                    var x = Math.sin(a) * this.radius + this.center[0];
                    var y = Math.cos(a) * this.radius + this.center[1];
                    return {
                        top: y + "px",
                        left: x + "px"
                    };
                }
            };
            $.fx.step.path = function (fx) {
                var css = fx.end.css(1 - fx.pos);
                for (var i in css) {
                    fx.elem.style[i] = css[i];
                }
            };

            // KENO DRAWINGS ANIMATION /////////////////////////////////
            // VARIABLES
            var theme = 'general';
            var badBrowser = false;
            var stage = $('#kenoPlayer');
            var step;
            var skip = false;
            var playerBG = null; // added dynamically based on theme
            var logo = $('#KENOlogo');
            var kenoPlayerIntro = $('#kenoPlayerIntro');
            var drawStart = $('.drawStart');
            var drawingStart = $('.drawStart');
            var kenoPlayerClose = $('#kenoPlayerClose');
            var kenoComingUp = $('#kenoComingUp');
            var kenoDrawLbl = $('#kenoDrawLbl');
            var kenoDrawNumber = $('.kenoDrawNumber');
            var kenoBoosterLbl = $('#kenoBoosterLbl');
            var kenoBoosterBack = $('#kenoBoosterBack');
            var boosterVal = $('#boosterVal');
            var kenoBoosterBall = null; // added dynamically based on theme
            var kenoGrid = $('#kenoGrid');
            var kenoNumber = $('.kenoNumber');
            var winVal;
            var kenoWinningGrid = $('#kenoWinningGrid');
            var kenoPlayerFooter = $('#kenoPlayerFooter');
            var kenoControls = $('#kenoControls');
            var btnKenoPlay = $('.btnKenoPlay');
            var paused = false;
            var btnKenoResults = $('.btnKenoResults');
            var kenoCtrlSkip = $('.kenoCtrlSkip');
            var btnKenoPrev = $('.btnKenoPrev');
            var btnKenoNext = $('.btnKenoNext');
            var prevNextSkip = false;
            var kenoThemes = $('#kenoThemes');
            var themeHdr = $('#themeHdr');
            var themeOptionLink = $('.themeOptionLink');
            var themeGeneric = $('.themeGeneric');
            var themeBaseball = $('.themeBaseball');
            var themeBlackJack = $('.themeBlackJack');
            var kenoSpecificDraw = $('#kenoSpecificDraw');
            var drawNumberInput = $('#drawNumber');
            var drawNum;
            var numError = $('.numberError');
            var drawingError = $('#drawingError');
            var drawCheck = /\D/g; // any non-digits?
            var drawingNumber;
            var drawQuantity = $('#drawQuantity');
            var drawQua;
            var drawRepeat = 0;
            var drawCycle = 0;
            var multiDraw = false;
            var kenoSpecificSubmit = $('#kenoSpecificSubmit');
            var counter;
            var winData;
            var winners;
            var boosterNumber;
            var playerImg = $('#playerImg');
            var winBallCount = 0;
            var idCheck = /(\d\d|\d)$/g;
            var winBallHTM;

            // use available arguments
            // if (themeString !== '') {
            //     theme = themeString;
            // }
            // if (multiDrawBool !== '') {
            //     multiDraw = multiDrawBool;
            // }

            // 0.0 - THEME OPTIONS ////////////////////////////////////////////////////////////////////
            themeOptionLink.click(function (e) {
                e.preventDefault();
                themeOptionLink.removeClass('themeActive');
                $(this).addClass('themeActive');
                theme = $(this).attr('id');
            });

            // 0.1 - CHECK FOR VALID DRAWING NUMBER ///////////////////////////////////////////////////////
            drawNumberInput.focus(function (e) {
                $(this).keyup(function () {
                    drawNum = $(this).val();
                    if (drawCheck.test(drawNum) == true) {
                        numError.html('Please enter a valid drawing number.');
                        _this.seqErrors.push('Please enter a valid drawing number.');
                    } else if (drawNum.length > 12) {
                        numError.html('The drawing number is too long.');
                        _this.seqErrors.push('The drawing number is too long.');
                    } else {
                        numError.html('');
                        _this.seqErrors = [];
                    }
                });
            });
            // 0.2 - WATCH SPECIFIC DRAWINGS FORM ////////////////////////////////////////////////////////
            kenoSpecificSubmit.click(function (e) {
                e.preventDefault();
                drawNum = _this.drawNumber;
                drawQua = drawQuantity.val();
                if (drawNum == '' || drawNum == null) {
                    numError.html('Please enter a drawing number.');
                    _this.seqErrors.push('Please enter a drawing number.');
                    return false;
                } else {
                    // error handle user input value
                    if (drawCheck.test(drawNum) == true) {
                        numError.html('Please enter a valid drawing number.');
                        _this.seqErrors.push('Please enter a valid drawing number.');
                        return false;
                    } else if (drawNum.length < 5) {
                        numError.html('The drawing number is too short.');
                        _this.seqErrors.push('The drawing number is too short.');
                        return false;
                    }
                    drawingNumber = drawNum;
                }

                if (drawQua > 1) {
                    multiDraw = true;
                    // drawingNumber = drawNum - drawQua;
                    drawingNumber = drawNum;
                }
                drawRepeat = drawQua;
                theme = $('.themeActive').attr('id');
                seqDraw('start');
            });
            // 0.3 - AJAX FOR SPECIFIC DRAWING DATA //////////////////////////////////////////////////////
            function seqDraw(nextFunc) {
                winners = ''; // reset winners array

                const apiRequestOptions = {
                    method: "GET",
                    headers: {
                        'Authorization': 'Bearer ' + _this.apiToken,
                        "Content-Type": "application/json"
                    }
                };
                fetch(process.env.VUE_APP_APIPROTOCOL + process.env.VUE_APP_APIURL + '/1.0/Games/DrawGames/Keno/SearchByDrawNumber?drawId=' + drawingNumber, apiRequestOptions)
                    .then(response => response.json())
                    .then(json => {
                        _this.drawData = json.data;
                        //Sort Data By Position
                        const sortWinningNumbersByPosition = _this.drawData.winningNumbers.sort((a, b) => a.position - b.position);
                        // console.log(sortWinningNumbersByPosition);
                        if (_this.drawData == '' || _this.drawData == null || !sortWinningNumbersByPosition.length) {
                            drawError(nextFunc);
                        } else {
                            let boostPos = '';
                            for (let i = 0; i < sortWinningNumbersByPosition.length; i++) {
                                if (sortWinningNumbersByPosition[i].modifier == 4) {
                                    boosterNumber = sortWinningNumbersByPosition[i].value;
                                    boostPos = i;
                                }
                            };
                            // remove from array
                            sortWinningNumbersByPosition.splice(boostPos, 1);
                            winners = sortWinningNumbersByPosition;

                            ajaxReturn(nextFunc);
                        }
                    });
            }
            // 0.4 - AJAX RETURN FOR SPECIFIC DRAW //////////////////////////////////////////////////////
            function ajaxReturn(nextFunc) {
                if (winners == '' || winners == null && nextFunc == 'start') {
                    drawError(nextFunc);
                }
                if (winners == '' || winners == null && nextFunc == 'booster') {
                    drawError(nextFunc);
                }
                if (nextFunc == 'start') {
                    startDrawing();
                } else if (nextFunc == 'booster') {
                    boosterBall();
                }
            }
            // 0.5 - DRAWING DATA ERROR HANDLING /////////////////////////////////////////////////////////
            function drawError(nextFunc) {
                if (nextFunc == 'start') {
                    kenoThemes.slideUp(500);
                    kenoSpecificDraw.slideUp(500);
                    themeHdr.slideUp(500);
                    kenoSpecificSubmit.hide();
                    drawStart.hide();
                    drawingError.html('There does not appear to be data for the drawing number you provided. Please check the number and try again.');
                    drawingError.fadeIn(750).delay(5000).fadeOut(500, function () {
                        kenoThemes.slideDown(500);
                        kenoSpecificDraw.slideDown(500);
                        themeHdr.slideDown(500);
                        kenoSpecificSubmit.show();
                        drawStart.show();
                    });
                } else if (nextFunc == 'booster') {
                    kenoControls.slideUp(500);
                    drawingError.html('You have viewed the most recent drawing, try again in a few minutes. KENO drawings occur every 4 minutes, daily from 6:04am until 2:28am the next morning.');
                    drawingError.fadeIn(500).delay(6500).fadeOut(20, function () {
                        resetStage();
                    });
                }

            }
            // 0.6 - WATCH A LIVE DRAWING ///////////////////////////////////////////////////////////////
            drawingStart.click(function (e) {
                theme = 'general'; // override user selection for latest drawing
                multiDraw = false;
                e.preventDefault();

                const apiRequestOptions = {
                    method: "GET",
                    headers: {
                        'Authorization': 'Bearer ' + _this.apiToken,
                        "Content-Type": "application/json"
                    }
                };

                fetch(process.env.VUE_APP_APIPROTOCOL + process.env.VUE_APP_APIURL + '/1.0/Games/DrawGames/Keno/GetLatestDraws', apiRequestOptions)
                    .then(response => response.json())
                    .then(json => {
                        _this.drawData = json.data[0];
                        // console.log(_this.drawData);
                        //Sort Data By Position
                        const sortWinningNumbersByPosition = _this.drawData.numbers.sort((a, b) => a.position - b.position);
                        // boosterNumber = _this.drawData.numbers.pop();
                        // boosterNumber = boosterNumber.value;
                        // winners = _this.drawData.numbers.slice(0,20);
                        drawingNumber = _this.drawData.externalDrawId;

                        let boostPos = '';
                        for (let i = 0; i < sortWinningNumbersByPosition.length; i++) {
                            if (sortWinningNumbersByPosition[i].modifier == 4) {
                                boosterNumber = sortWinningNumbersByPosition[i].value;
                                boostPos = i;
                            }
                        };
                        // remove from array
                        sortWinningNumbersByPosition.splice(boostPos, 1);
                        winners = sortWinningNumbersByPosition;
                        // console.log(winners);

                        startDrawing();
                    });
            });
            // 1.0 - FIRST STEP OF DRAWING ANIMATION ///////////////////////////////////////////////////////////////
            function startDrawing() {
                step = 'startDrawing';
                if (multiDraw == true) {
                    kenoCtrlSkip.show();
                    _this._kenoButtonToggle(btnKenoPrev, 'off');
                    _this._kenoButtonToggle(btnKenoNext, 'on');
                    //_gaq.push(['_trackEvent', 'KenoDrawings', 'WatchSpecific', 'Consecutive', drawQua]); // GA event tracking
                    //_gaq.push(['_trackEvent', 'KenoDrawings', 'Theme', theme]); // GA event tracking
                } else {
                    kenoCtrlSkip.hide();
                    //_gaq.push(['_trackEvent', 'KenoDrawings', 'WatchLatest']); // GA event tracking
                }
                _this._kenoPlayButton('off');
                kenoControls.slideDown(250);
                kenoThemes.slideUp(250);
                themeHdr.slideUp(250);
                kenoSpecificDraw.slideUp(250);
                kenoPlayerIntro.fadeOut(500);
                stage.addClass(theme);
                // set stage with themed items
                if (theme === 'baseball') { // *************************************************
                    stage.append('<image src="/site_images/keno-to-go/baseball/keno-ball.png" id="kenoBoosterBall">');
                    kenoBoosterBall = $('#kenoBoosterBall');
                    stage.append('<image src="/site_images/keno-to-go/baseball/bg-keno-baseball.jpg" id="playerBG" />');
                    playerBG = $('#playerBG');
                    playerBG.fadeIn(1000);
                    logo.fadeOut(1000, function () {
                        kenoDrawNumber.html(drawingNumber);
                        kenoDrawLbl.fadeIn(500);
                        kenoGrid.show(0, function () {
                            boosterBall();
                        });
                    });
                } else if (theme === 'blackjack') { // *************************************************
                    stage.append('<image src="/site_images/keno-to-go/blackjack/keno-back.png" id="kenoBoosterBack">');
                    kenoBoosterBack = $('#kenoBoosterBack');
                    stage.append('<image src="/site_images/keno-to-go/blackjack/keno-back.png" id="kenoBoosterBall">');
                    kenoBoosterBall = $('#kenoBoosterBall');
                    stage.append('<div id="playerBG"> </div>');
                    playerBG = $('#playerBG');
                    playerBG.fadeIn(1000);
                    logo.fadeOut(1000, function () {
                        kenoDrawNumber.html(drawingNumber);
                        kenoDrawLbl.fadeIn(500);
                        kenoGrid.delay(500).slideDown(750, function () {
                            boosterBall();
                        });
                    });
                } else {
                    // } else if (theme === 'general') { // *************************************************
                    theme = 'general'
                    if ($('.no-cssgradients').length) {
                        badBrowser = true;
                        stage.append('<image src="/site_images/keno-to-go/keno-ball-red.png" id="kenoBoosterBall">');
                    } else {
                        stage.append('<div id="kenoBoosterBall"> </div>');
                    }
                    kenoBoosterBall = $('#kenoBoosterBall');
                    stage.append('<div id="playerBG"> </div>');
                    playerBG = $('#playerBG');
                    playerBG.fadeIn(1000);
                    logo.animate({
                        width: '363px',
                        left: '159px',
                        top: '125px'
                    }, {
                        duration: 1000,
                        // easing: 'easeInOutCirc',
                        easing: 'linear',
                        complete: function () {
                            kenoDrawNumber.html(drawingNumber);
                            kenoDrawLbl.fadeIn(250);
                            boosterBall();
                        }
                    });
                }
            }
            // 1.1 - START BOOSTER BALL ////////////////////////////////////////////////////////////////////
            function boosterBall() {
                step = 'boosterBall';
                if (boosterNumber > 0) {
                    if (theme === 'general' && skip == false) { // *************************************************
                        kenoBoosterBall.show(250).animate({
                            width: '50px',
                            height: '50px',
                            top: '-55px',
                            left: '320px'
                        }, {
                            queue: false,
                            duration: 1000,
                            easing: 'linear',
                            complete: function () {
                                boosterReveal();
                            }
                        });
                    } else if (theme === 'baseball' && skip == false) { // *************************************************
                        kenoBoosterBall.show().animate({
                            width: '175px',
                            height: '175px',
                            top: '-180px',
                            left: '253px'
                        }, {
                            queue: false,
                            duration: 1000,
                            easing: 'linear',
                            complete: function () {
                                boosterReveal();
                            }
                        });
                    } else if (theme === 'blackjack' && skip == false) { // *************************************************
                        kenoBoosterBack.slideDown(175).animate({
                            top: '113px',
                            left: '286px'
                        }, {
                            queue: false,
                            duration: 1000,
                            // easing: 'easeInOutCirc',
                            easing: 'linear',
                            complete: function () {
                                kenoBoosterBall.slideDown(175).animate({
                                    top: '157px',
                                    left: '436px',
                                    width: '1px'
                                }, {
                                    queue: false,
                                    duration: 500,
                                    easing: 'linear',
                                    complete: function () {
                                        boosterReveal();
                                    }
                                });
                            }
                        });
                    }
                } else {
                    // skip booster and start showing winning balls
                    if (theme === 'general') {
                        logo.animate({
                            width: '142px',
                            left: '274px',
                            top: '7px'
                        }, {
                            duration: 1000,
                            // easing: 'easeInOutCirc',
                            easing: 'linear',
                            complete: function () {
                                startPick();
                            }
                        });
                        kenoGrid.delay(1000).show();
                    } else {
                        startPick();
                    }
                }
            }
            // 1.2 - SHOW BOOSTER VALUE ////////////////////////////////////////////////////////////////////
            function boosterReveal() {
                if (skip == false) {
                    step = 'boosterReveal';
                    // FOR CSS2, PUT <div> OVER <img>
                    if (badBrowser == true && theme === 'general') { // *************************************************
                        kenoBoosterBall.css({ 'height': '260px', 'width': '260px', 'left': '203px', 'z-index': '75', 'opacity': '1' })
                            .attr('src', '/site_images/keno-to-go/keno-boost-' + boosterNumber + '.png')
                            .animate({
                                width: '287px',
                                height: '287px',
                                top: '67px',
                                left: '190px'
                            }, {
                                duration: 750,
                                // easing: 'easeOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    boosterVal.html(boosterNumber);
                                    _this._kenoPlayButton('on');
                                    counter = setTimeout(boosterRemove, 5000);
                                }
                            });
                    } else if (theme === 'general') { // *************************************************
                        if (boosterNumber == '10') {
                            kenoBoosterBall.css('fontSize', '130px');
                        }
                        kenoBoosterBall.css({ 'height': '260px', 'width': '260px', 'left': '203px', 'z-index': '75', 'opacity': '1' })
                            .html(boosterNumber + 'X<div class="boostTxt">BOOSTER<span class="tm">&reg;</span></div>')
                            .animate({
                                width: '287px',
                                height: '287px',
                                top: '67px',
                                left: '190px'
                            }, {
                                duration: 750,
                                // easing: 'easeOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    boosterVal.html(boosterNumber);
                                    _this._kenoPlayButton('on');
                                    counter = setTimeout(boosterRemove, 5000);
                                }
                            });
                    } else if (theme === 'baseball') { // *************************************************
                        kenoBoosterBall.css({ 'height': '200px', 'width': '200px', 'left': '241px', 'z-index': '75' })
                            .attr('src', '/site_images/keno-to-go/baseball/keno-boost-' + boosterNumber + '.png')
                            .animate({
                                width: '250px',
                                height: '250px',
                                top: '100px',
                                left: '216px'
                            }, {
                                duration: 750,
                                // easing: 'easeOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    boosterVal.html(boosterNumber);
                                    _this._kenoPlayButton('on');
                                    counter = setTimeout(boosterRemove, 4000);
                                }
                            });
                    } else if (theme === 'blackjack') { // *************************************************
                        kenoBoosterBall.attr('src', '/site_images/keno-to-go/blackjack/keno-boost-' + boosterNumber + '.png')
                            .animate({
                                width: '64px',
                                top: '97px',
                                left: '306px'
                            }, {
                                duration: 750,
                                // easing: 'easeOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    boosterVal.html(boosterNumber);
                                    _this._kenoPlayButton('on');
                                    counter = setTimeout(boosterRemove, 4000);
                                }
                            });

                    }
                }
            }
            // 1.3 - REMOVE BOOSTER & SHOW LABELS ////////////////////////////////////////////////////////////////////
            var boosterRemove = function () {
                _this._kenoPlayButton('off');
                if (skip == false) {
                    step = 'boosterRemove';
                    if (theme === 'general') { // *************************************************
                        $('.boostTxt').fadeOut(250);
                        kenoBoosterBall.animate({
                            top: '8px',
                            left: '519px',
                            height: '40px',
                            width: '40px',
                            fontSize: '26px',
                            lineHeight: '1.5em'
                        }, {
                            duration: 500,
                            complete: function () {
                                kenoBoosterBall.fadeOut(250).css({ 'z-index': '15', 'left': '330px', 'fontSize': '163px', 'lineHeight': '250px', 'top': '500px', 'opacity': '1' });
                                if (badBrowser == true) {
                                    kenoBoosterBall.replaceWith('<image src="/site_images/keno-to-go/keno-ball-red.png" id="kenoBoosterBall" />');
                                    kenoBoosterBall = $('#kenoBoosterBall');
                                }
                                kenoBoosterLbl.fadeIn(250);
                                $('.boostTxt').delay(300).show();
                            }
                        });
                        logo.animate({
                            width: '142px',
                            left: '274px',
                            top: '7px'
                        }, {
                            duration: 1000,
                            // easing: 'easeInOutCirc',
                            easing: 'linear',
                            complete: function () {
                                // reveal number grid
                                kenoGrid.delay(500).show(0, function () { startPick(); });
                            }
                        });
                    } else if (theme === 'baseball') { // *************************************************
                        kenoBoosterBall.animate({
                            top: '8px',
                            left: '519px',
                            height: '40px',
                            width: '40px'
                        }, {
                            duration: 500,
                            complete: function () {
                                kenoBoosterBall.fadeOut(250).css({ 'width': '40px', 'height': '40px', 'z-index': '75', 'left': '330px', 'top': '500px' }).attr('src', '/site_images/keno-to-go/baseball/keno-ball.png');
                                kenoBoosterLbl.fadeIn(250);
                                stage.append('<div id="playerImg"> </div>');
                                playerImg = $('#playerImg');
                                playerImg.fadeIn(500, function () { startPick(); });
                            }
                        });
                    } else if (theme === 'blackjack') { // *************************************************
                        kenoBoosterBall.animate({
                            top: '4px',
                            left: '524px',
                            width: '32px',
                            height: '45px'
                        }, {
                            duration: 750,
                            complete: function () {
                                kenoBoosterBall.fadeOut(250, function () {
                                    kenoBoosterBall.css({ 'left': '578px', 'top': '86px', 'width': '64px', 'height': '91px' }).attr('src', '/site_images/keno-to-go/blackjack/keno-back.png');
                                });
                                kenoBoosterLbl.fadeIn(250);
                            }
                        });
                        kenoBoosterBack.delay(750).animate({
                            top: '-90px',
                            left: '286px'
                        }, {
                            queue: false,
                            duration: 750,
                            // easing: 'easeInCirc',
                            easing: 'linear',
                            complete: function () {
                                kenoBoosterBack.hide().css({ 'left': '578px', 'top': '86px' });
                                startPick();
                            }
                        });
                    }
                }
            };
            // 2.0 - CREATE WINNING NUMBERS ////////////////////////////////////////////////////////////////////
            function startPick() {
                if (skip == false) {
                    step = 'startPick';
                    // parse winning number array
                    var i = 0;
                    for (i; i < winners.length; i++) {
                        var winVal = winners[i].value;
                        var winSeq = 'win' + i;
                        var winId = 'win' + winVal;
                        // handle theme and CSS2
                        if (badBrowser == true && theme == 'general') {
                            winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/keno-red_' + winVal + '.png">';
                        } else if (theme == 'general') {
                            winBallHTM = '<div class="winningBall ' + winSeq + '" id="' + winId + '"></div>';
                        } else if (theme == 'baseball') {
                            winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/baseball/keno-ball.png">';
                        } else if (theme == 'blackjack') {
                            winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/blackjack/keno-back.png">';
                        }
                        stage.append(winBallHTM);
                    };
                    //alert(step + ' complete');
                    showCycle();
                }
            }
            // 2.1 - SHOW WINNING BALLS CYCLE ////////////////////////////////////////////////////////////////////
            var showCycle = function () {
                //alert(winBallCount);
                if (winBallCount < 20) {
                    if (skip == false)
                        showWin();
                } else {
                    if (skip == false)
                        sortGrid();
                    winBallCount = 0;
                }
            };
            // 2.2 - NUMBER ANIMATION ////////////////////////////////////////////////////////////////////
            function showWin() {
                // run once for each winning ball
                if (skip == false) {
                    var theWin = $('.win' + winBallCount);
                    var theId = theWin.attr('id');
                    var winVal = theId.match(idCheck);
                    var gridLoc = $('#ball' + winVal).position();
                    var gridTop = gridLoc.top;
                    var gridLeft = gridLoc.left;
                    if (theme == 'general') {
                        // GENERAL THEME ANIMATION ************************************
                        theWin.animate({
                            width: '140px',
                            height: '140px',
                            left: '271px',
                            top: '176px',
                            queue: false
                        }, {
                            duration: 400,
                            // easing: 'easeOutCirc',
                            easing: 'linear',
                            complete: function () {
                                if (badBrowser == false) {
                                    $(this).html('<span>' + winVal + '</span>');
                                }
                            }
                        }).delay(1700).animate({
                            width: '37px',
                            height: '37px',
                            left: gridLeft,
                            top: gridTop,
                            fontSize: '24px',
                            queue: false
                        }, {
                            duration: 400,
                            // easing: 'easeInOutCirc',
                            easing: 'linear',
                            complete: function () {
                                winBallCount++;
                                showCycle();
                            }
                        });
                    } else if (theme === 'baseball') {
                        // BASEBALL THEME ANIMATION ************************************
                        var bb_left = gridLeft + 12;
                        var bb_top = gridTop + 15;
                        var bb_path = new path.bezier({
                            start: { x: 430, y: 300, angle: 0, length: 0.1 },
                            end: { x: bb_left, y: bb_top, angle: -105, length: 1.5 }
                        });
                        function bbPath() {
                            theWin.animate({
                                width: '2px',
                                height: '2px',
                                path: bb_path,
                                queue: false
                            }, {
                                duration: 1500,
                                // easing: 'easeOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    winBallCount++;
                                    theWin.hide();
                                    $('#ball' + winVal).addClass('kenoNumberWin');
                                    stage.append('<img src="/site_images/keno-to-go/baseball/bb-crash.png" id="bbCrash">');
                                    $('#bbCrash').css({
                                        'left': gridLeft + 8,
                                        'top': gridTop + 8,
                                        'display': 'block'
                                    }).animate({
                                        width: '100px',
                                        height: '100px',
                                        left: gridLeft - 36,
                                        top: gridTop - 36,
                                        opacity: 0.3
                                    }, {
                                        duration: 550,
                                        easing: 'linear',
                                        complete: function () {
                                            $('#bbCrash').remove();
                                        }
                                    });
                                    counter = setTimeout(showCycle, 2000);
                                }
                            });
                        }
                        var frameCount = 0;
                        var bgPosition = 0;
                        var bgVariable = 244;
                        function swingBatter() {
                            if (frameCount === 7) {
                                // start ball path function
                                bbPath();
                                bgPosition = bgPosition - bgVariable;
                                playerImg.css('background-position', '0 ' + bgPosition + 'px');
                            } else if (frameCount == 15) {
                                // stop and reset
                                clearTimeout(swingFrame);
                                frameCount = 0;
                                bgPosition = 0;
                                playerImg.css('background-position', '0 0');
                                return false;
                            } else {
                                // normal frame
                                bgPosition = bgPosition - bgVariable;
                                playerImg.css('background-position', '0 ' + bgPosition + 'px');
                            }
                            frameCount = frameCount + 1;
                            var swingFrame = setTimeout(swingBatter, 100);
                        }
                        swingBatter();
                    } else if (theme === 'blackjack') {
                        // BLACKJACK THEME ANIMATION ************************************
                        theWin.slideDown(175).animate({
                            top: '157px',
                            left: '436px',
                            width: '1px'
                        }, {
                            queue: true,
                            duration: 500,
                            // easing: 'easeInCirc',
                            easing: 'linear',
                            complete: function () {
                                theWin.attr('src', '/site_images/keno-to-go/blackjack/keno-bj_' + winVal + '.png').animate({
                                    width: '64px',
                                    top: '97px',
                                    left: '312px'
                                }, {
                                    duration: 500,
                                    // easing: 'easeOutCirc',
                                    easing: 'linear',
                                    complete: function () {
                                        counter = setTimeout(removeTheWin, 2500);
                                    }
                                });
                            }
                        });
                        function removeTheWin() {
                            $('#ball' + winVal).addClass('kenoNumberWin');
                            theWin.animate({
                                top: '-95px'
                            }, {
                                queue: true,
                                duration: 750,
                                // easing: 'easeInCirc',
                                easing: 'linear',
                                complete: function () {
                                    winBallCount++;
                                    showCycle();
                                }
                            });
                        }
                    }
                }
            }
            // 2.3 - PRESENT WINNING NUMBERS IN FINAL GRID //////////////////////////////////////////////
            var sortGrid = function () {
                step = 'results';
                var restartTime = 10000;
                _this._kenoButtonToggle(btnKenoResults, 'off');
                if (theme == 'general') {
                    // GENERAL THEME RESULTS ************************************
                    kenoGrid.delay(500).hide();
                    var i = 0;
                    var index = 0;
                    for (i; i < 81; i++) {
                        if ($('#win' + i).length) {
                            var xMulti = 90;
                            var yMulti = 85;
                            var initX = 130;
                            var initY = 83;
                            var moveX = initX;
                            var moveY = 0;
                            if (index < 5) {
                                moveY = initY;
                            } else if (index >= 5 && index < 10) {
                                moveY = initY + yMulti;
                            } else if (index >= 10 && index < 15) {
                                moveY = initY + (2 * yMulti);
                            } else if (index >= 15) {
                                moveY = initY + (3 * yMulti);
                            }
                            if (index == 1 || index == 6 || index == 11 || index == 16) {
                                moveX = initX + xMulti;
                            } else if (index == 2 || index == 7 || index == 12 || index == 17) {
                                moveX = initX + (2 * xMulti);
                            } else if (index == 3 || index == 8 || index == 13 || index == 18) {
                                moveX = initX + (3 * xMulti);
                            } else if (index == 4 || index == 9 || index == 14 || index == 19) {
                                moveX = initX + (4 * xMulti);
                            }
                            if (skip == false) {
                                restartTime = 10750;
                                $('#win' + i).animate({
                                    width: '70px',
                                    height: '70px',
                                    left: moveX + 'px',
                                    top: moveY + 'px',
                                    fontSize: '45px'
                                }, {
                                    duration: 750,
                                    easing: 'linear'
                                });
                            } else {
                                $('#win' + i).css({
                                    'width': '70px',
                                    'height': '70px',
                                    'left': moveX + 'px',
                                    'top': moveY + 'px',
                                    'fontSize': '45px'
                                });
                            }
                            index++;
                        }
                    }
                } else if (theme === 'baseball') {
                    // BASEBALL THEME RESULTS ************************************
                    if (skip == false) {
                        restartTime = 16000;
                        playerImg.animate({
                            left: '600px',
                            top: '400px'
                        }, {
                            duration: 1250,
                            complete: function () {
                                playerImg.remove();
                            }
                        });
                        kenoGrid.hide();
                        playerBG.animate({
                            'min-width': '890px',
                            height: '610px'
                        }, {
                            duration: 1000,
                            // easing: 'easeInOutCirc'
                            easing: 'linear'
                        });
                    }
                    var i = 0;
                    var index = 0;
                    for (i; i < 81; i++) {
                        if ($('#win' + i).length) {
                            var xMulti = 101;
                            var yMulti = 66;
                            var initX = 110;
                            var initY = 130;
                            var moveX = initX;
                            var moveY = 0;
                            if (index < 5) {
                                moveY = initY;
                                moveX = initX + (xMulti * index);
                            } else if (index > 4 && index < 10) {
                                moveY = initY + yMulti;
                                moveX = initX + (xMulti * (index - 5));
                            } else if (index > 9 && index < 15) {
                                moveY = initY + (2 * yMulti);
                                moveX = initX + (xMulti * (index - 10));
                            } else if (index > 14) {
                                moveY = initY + (3 * yMulti);
                                moveX = initX + (xMulti * (index - 15));
                            }
                            if (skip == false) {
                                $('#win' + i).css({
                                    'width': '60px',
                                    'height': '60px',
                                    'left': moveX + 'px',
                                    'top': moveY + 'px'
                                }).delay(3000).after('<div class="bbWinNum" id="bbWinNum' + i + '">' + i + '</div>').fadeIn(500);
                                $('#bbWinNum' + i).css({ 'left': moveX + 'px', 'top': moveY + 'px' }).delay(3000).fadeIn(500);
                            } else {
                                $('#win' + i).css({
                                    'width': '60px',
                                    'height': '60px',
                                    'left': moveX + 'px',
                                    'top': moveY + 'px'
                                }).after('<div class="bbWinNum" id="bbWinNum' + i + '">' + i + '</div>');
                                $('#bbWinNum' + i).css({ 'left': moveX + 'px', 'top': moveY + 'px' }).show();
                            }
                            index++;
                        }
                    }
                } else if (theme === 'blackjack') {
                    // BLACKJACK THEME RESULTS ************************************
                    kenoGrid.slideUp(500);
                    var i = 0;
                    var index = 0;
                    for (i; i < 81; i++) {
                        if ($('#win' + i).length) {
                            var xMulti = 102;
                            var yMulti = 82;
                            var initX = 106;
                            var initY = 90;
                            var moveX = initX;
                            var moveY = 0;
                            var delayX = index * 50 + 750;
                            var zIndeX = '90' + index;
                            if (index < 5) {
                                moveY = initY;
                                moveX = initX + (xMulti * index);
                            } else if (index > 4 && index < 10) {
                                moveY = initY + yMulti;
                                moveX = initX + (xMulti * (index - 5));
                            } else if (index > 9 && index < 15) {
                                moveY = initY + (yMulti * 2);
                                moveX = initX + (xMulti * (index - 10));
                            } else if (index > 14) {
                                moveY = initY + (yMulti * 3);
                                moveX = initX + (xMulti * (index - 15));
                            }
                            if (skip == false) {
                                restartTime = 14000;
                                $('#win' + i).css('zIndex', zIndeX).delay(delayX).animate({
                                    'width': '56px',
                                    'height': '80px',
                                    left: moveX + 'px',
                                    top: moveY + 'px',
                                    queue: true,
                                }, {
                                    duration: 1500,
                                    // easing: 'easeOutCirc'
                                    easing: 'linear'
                                });
                            } else {
                                $('#win' + i).css({
                                    'z-index': zIndeX,
                                    'left': moveX + 'px',
                                    'top': moveY + 'px',
                                    'width': '56px',
                                    'height': '80px'
                                });
                            }
                            index++;
                        }
                    }
                }
                _this._kenoPlayButton('on');
                counter = setTimeout(clearStartNext, restartTime);
            };
            // 3.0 - SKIP TO RESULTS BUTTON ////////////////////////////////////////////////////////////////////
            btnKenoResults.click(function (event) {
                //_gaq.push(['_trackEvent', 'KenoDrawings', 'SkipToResults', step]); // GA event tracking
                skipToEnd();
                event.preventDefault();
            });
            // 3.1 - SKIP TO RESULTS FUNCTION ///////////////////////////////////////////////////////////////////
            function skipToEnd() {
                skip = true;
                if (theme == 'general') {
                    // GENERAL THEME SKIP ************************************
                    if (step === 'startDrawing') {
                        kenoBoosterBall.stop().fadeOut();
                        logo.stop();
                        if (prevNextSkip == false) {
                            logo.animate({
                                width: '150px',
                                left: '270px',
                                top: '8px'
                            }, {
                                duration: 500,
                                // easing: 'easeInOutCirc'
                                easing: 'linear'
                            });
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                        }
                        //alert(step);
                        skipToResults();
                    } else if (step === 'boosterBall' || step === 'boosterReveal') {
                        kenoBoosterBall.stop().fadeOut();
                        logo.stop();
                        if (prevNextSkip == false) {
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                            logo.animate({
                                width: '150px',
                                left: '270px',
                                top: '8px'
                            }, {
                                duration: 500,
                                // easing: 'easeInOutCirc'
                                easing: 'linear'
                            });
                        }
                        clearTimeout(counter);
                        //alert(step);
                        skipToResults();
                    } else if (step === 'boosterRemove') {
                        clearTimeout(counter);
                        kenoBoosterBall.stop().fadeOut();
                        logo.stop();
                        if (prevNextSkip == false) {
                            logo.animate({
                                width: '150px',
                                left: '270px',
                                top: '8px'
                            }, {
                                duration: 500,
                                // easing: 'easeInOutCirc'
                                easing: 'linear'
                            });
                        } else if (prevNextSkip == true) {
                            kenoBoosterLbl.hide();
                        }
                        kenoGrid.hide();
                        //alert(step);
                        skipToResults();
                    } else if (step === 'startPick') {
                        $('.winningBall').stop(true).remove();
                        winBallCount = 0;
                        kenoGrid.hide();
                        clearTimeout(counter);
                        //alert(step);
                        skipToResults();
                    } else {
                        //alert('unknown step');
                    }
                } else if (theme === 'baseball') {
                    // BASEBALL THEME SKIP ************************************
                    if (step === 'startDrawing') {
                        kenoBoosterBall.stop(true, true).fadeOut();
                        if (prevNextSkip == false) {
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                        }
                        kenoGrid.hide();
                        skipToResults();
                    } else if (step === 'boosterBall' || step === 'boosterReveal') {
                        kenoBoosterBall.stop(true, true).fadeOut();
                        if (prevNextSkip == false) {
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                        }
                        kenoGrid.hide();
                        clearTimeout(counter);
                        skipToResults();
                    } else if (step === 'boosterRemove') {
                        clearTimeout(counter);
                        kenoBoosterBall.stop(true, true).fadeOut();
                        $('#playerImg').remove();
                        if (prevNextSkip == true) {
                            kenoBoosterLbl.hide();
                        }
                        kenoGrid.hide();
                        skipToResults();
                    } else if (step === 'startPick') {
                        $('.winningBall').stop(true).remove();
                        $('#playerImg').stop().remove();
                        winBallCount = 0;
                        kenoGrid.hide();
                        playerBG.stop(true, true);
                        clearTimeout(counter);
                        skipToResults();
                    } else {
                        //alert('unknown step');
                    }
                } else if (theme === 'blackjack') {
                    // BLACKJACK THEME SKIP ************************************
                    if (step === 'startDrawing') {
                        kenoBoosterBack.stop(false, true).hide().css({ 'left': '578px', 'top': '86px' });
                        kenoBoosterBall.stop(false, true).hide();
                        //alert(step);
                        if (prevNextSkip == false) {
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                        }
                        kenoGrid.slideUp(500, function () {
                            skipToResults();
                        });
                    } else if (step === 'boosterBall' || step === 'boosterReveal') {
                        kenoBoosterBack.stop(false, true).hide().css({ 'left': '578px', 'top': '86px' });
                        kenoBoosterBall.stop(false, true).hide();
                        //alert(step);
                        if (prevNextSkip == false) {
                            boosterVal.html(boosterNumber);
                            kenoBoosterLbl.fadeIn(250);
                        }
                        clearTimeout(counter);
                        kenoGrid.slideUp(500, function () {
                            skipToResults();
                        });
                    } else if (step === 'boosterRemove') {
                        clearTimeout(counter);
                        kenoBoosterBack.stop(false, true).hide().css({ 'left': '578px', 'top': '86px' });
                        kenoBoosterBall.stop(false, true).hide();
                        //alert(step);
                        if (prevNextSkip == true) {
                            kenoBoosterLbl.hide();
                        }
                        kenoGrid.slideUp(500, function () {
                            skipToResults();
                        });
                    } else if (step === 'startPick') {
                        $('.winningBall').stop(true).remove();
                        winBallCount = 0;
                        clearTimeout(counter);
                        kenoGrid.slideUp(500, function () {
                            skipToResults();
                        });
                    } else {
                        //alert('unknown step');
                    }
                } else {
                    // assumme custom theme
                    //alert(hartCustomTheme);
                }
            }
            // 3.2 - SORT FUNCTION ////////////////////////////////////////////////////////////////////
            function sortfunc(a, b) {
                return a - b;
            }
            // 3.3 - SET UP RESULTS FOR SKIP /////////////////////////////////////////////////////////
            function skipToResults() {
                if (theme == 'general') { // ***********************************************
                    kenoBoosterBall.css({ 'z-index': '15', 'left': '330px', 'fontSize': '163px', 'lineHeight': '250px', 'top': '500px', 'opacity': '1' });
                    if (prevNextSkip == false) {
                        _this._kenoButtonToggle(btnKenoResults, 'off');
                        var i = 0;
                        winners.sort(sortfunc);
                        for (i; i < winners.length; i++) {
                            var winVal = winners[i].value;
                            var winSeq = 'win' + i;
                            var winId = 'win' + winVal;
                            if (badBrowser == true) {
                                winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/keno-red_' + winVal + '.png">';
                            } else {
                                winBallHTM = '<div class="winningBall ' + winSeq + '" id="' + winId + '">' + winVal + '</div>';
                            }
                            stage.append(winBallHTM);
                            $('#' + winId).css('top', '200px');
                        };
                        sortGrid();
                    } else {
                        clearStartNext();
                    }
                } else if (theme === 'baseball') { // ***********************************************
                    kenoBoosterBall.css({ 'width': '40px', 'height': '40px', 'left': '320px', 'top': '500px', 'z-index': '75' }).attr('src', '/site_images/keno-to-go/baseball/keno-ball.png');
                    if (prevNextSkip == false) {
                        //this._kenoButtonToggle(kenoCtrlSkip,'off');
                        kenoNumber.removeClass('kenoNumberWin');
                        playerBG.css({ 'min-width': '890px', height: '610px' });
                        var i = 0;
                        for (i; i < winners.length; i++) {
                            var winVal = winners[i].value;
                            var winSeq = 'win' + i;
                            var winId = 'win' + winVal;
                            winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/baseball/keno-ball.png">';
                            stage.append(winBallHTM);
                        };
                        sortGrid();
                    } else {
                        clearStartNext();
                    }
                } else if (theme === 'blackjack') { // ***********************************************
                    kenoBoosterBall.css({ 'left': '578px', 'top': '86px', 'width': '64px', 'height': '91px' }).attr('src', '/site_images/keno-to-go/blackjack/keno-back.png');
                    if (prevNextSkip == false) {
                        _this._kenoButtonToggle(btnKenoResults, 'off');
                        kenoNumber.removeClass('kenoNumberWin');
                        var i = 0;
                        for (i; i < winners.length; i++) {
                            var winVal = winners[i].value;
                            var winSeq = 'win' + i;
                            var winId = 'win' + winVal;
                            $('#ball' + winVal).addClass('kenoNumberWin');
                            winBallHTM = '<img class="winningBall ' + winSeq + '" id="' + winId + '" src="/site_images/keno-to-go/blackjack/keno-bj_' + winVal + '.png">';
                            stage.append(winBallHTM);
                            $('#' + winId).show();
                        };
                        sortGrid();
                    } else {
                        clearStartNext();
                    }
                }
            }
            // 4.0 - CLEAR STAGE & SHOW COMING UP ///////////////////////////////////////////////////////////
            var clearStartNext = function () {
                step = 'clearStartNext';
                _this._kenoPlayButton('off');
                clearTimeout(counter);
                prevNextSkip = false;
                if (multiDraw == true) {
                    $('.winningBall').fadeOut(500).remove();
                    kenoDrawLbl.fadeOut(250);
                    kenoBoosterLbl.fadeOut(250);
                    drawCycle++;
                    if (drawRepeat > drawCycle) {
                        stage.css('backgroundPosition', 'center center');
                        if (drawCycle > 0) {
                            _this._kenoButtonToggle(btnKenoPrev, 'on');
                        } else {
                            _this._kenoButtonToggle(btnKenoPrev, 'off');
                        }
                        if (drawRepeat > (drawCycle + 1)) {
                            _this._kenoButtonToggle(btnKenoNext, 'on');
                        } else {
                            _this._kenoButtonToggle(btnKenoNext, 'off');
                        }
                        kenoControls.slideUp(250);
                        drawingNumber++;
                        kenoDrawNumber.html(drawingNumber);
                        kenoComingUp.fadeIn(750);
                        if (theme === 'baseball') {			// *********************************
                            kenoNumber.removeClass('kenoNumberWin');
                            $('.bbWinNum').fadeOut(250).remove();
                            counter = setTimeout(comingUp, 2500);
                        } else if (theme === 'blackjack') {			// *************************
                            $('.winningBall').css({ 'width': '64px', 'height': '91px' });
                            kenoNumber.removeClass('kenoNumberWin');
                            counter = setTimeout(comingUp, 2500);
                        } else if (theme === 'general') {		// ****************************************************
                            playerBG.fadeOut(250);
                            logo.animate({
                                width: '363px',
                                left: '159px',
                                top: '125px'
                            }, {
                                queue: false,
                                duration: 1000,
                                // easing: 'easeInOutCirc',
                                easing: 'linear',
                                complete: function () {
                                    counter = setTimeout(comingUp, 2500);
                                }
                            });
                        }
                    } else {
                        multiDraw = false;
                        resetStage();
                    }
                } else if (multiDraw == false) {
                    $('.winningBall').fadeOut(500).remove();
                    resetStage();
                }
            };
            // 4.1 - COMING UP BUMPER ANIMATION ////////////////////////////////////////////////////////////////////
            var comingUp = function () {
                step = 'comingUp';
                skip = false;
                kenoControls.slideDown(250);
                kenoDrawLbl.fadeIn(250);
                if (theme === 'baseball') { // ************************************
                    kenoComingUp.fadeOut(500, function () {
                        playerBG.animate({
                            'min-width': '682px',
                            'height': '467px'
                        }, {
                            duration: 1000,
                            // easing: 'easeInOutCirc',
                            easing: 'linear',
                            complete: function () {
                                kenoGrid.show();
                                seqDraw('booster');
                                _this._kenoButtonToggle(btnKenoResults, 'on');
                            }
                        });
                    });
                } else if (theme === 'blackjack') { // ************************************
                    kenoComingUp.fadeOut(500, function () {
                        kenoGrid.delay(250).slideDown(500, function () {
                            seqDraw('booster');
                            _this._kenoButtonToggle(btnKenoResults, 'on');
                        });
                    });
                } else {		// ************************************
                    kenoComingUp.fadeOut(500);
                    playerBG.fadeIn(500);
                    logo.animate({
                        width: '363px',
                        left: '159px',
                        top: '125px'
                    }, {
                        duration: 1000,
                        // easing: 'easeInOutCirc',
                        easing: 'linear',
                        complete: function () {
                            seqDraw('booster');
                            _this._kenoButtonToggle(btnKenoResults, 'on');
                        }
                    });
                }
            };
            // 4.2 - COMMON STAGE RESET - RETURNS TO MAIN VIEW ////////////////////////////////////////////////
            function resetStage() {
                skip = false;
                drawCycle = 0;
                prevNextSkip = false;
                _this._kenoButtonToggle(btnKenoResults, 'on');
                kenoDrawLbl.fadeOut(500);
                kenoBoosterLbl.fadeOut(500);
                kenoControls.slideUp(250);
                kenoThemes.slideDown(250);
                themeHdr.slideDown(250);
                kenoSpecificDraw.slideDown(250);
                kenoPlayerIntro.fadeIn(500);
                if (kenoBoosterBall != null) {
                    kenoBoosterBall.remove();
                }
                if (theme === 'baseball') {
                    kenoNumber.removeClass('kenoNumberWin');
                    $('.bbWinNum').fadeOut(500).remove();
                    logo.delay(500).fadeIn(500);
                } else if (theme === 'blackjack') {
                    kenoGrid.delay(500).slideUp(500, function () {
                        $('.winningBall').css({ 'width': '64px', 'height': '91px' });
                        kenoNumber.removeClass('kenoNumberWin');
                        logo.fadeIn(500);
                        kenoBoosterBack.remove();
                    });
                } else {
                    logo.animate({
                        width: '313px',
                        left: '60px',
                        top: '56px'
                    }, {
                        duration: 750,
                        // easing: 'easeInOutCirc'
                        easing: 'linear'
                    });
                }
                if (playerBG != null) {
                    playerBG.fadeOut(500).remove();
                }
                stage.delay(750).removeClass(theme);
            }
            // 5.0 - PAUSE PLAY BUTTON ////////////////////////////////////////////////////////////////////
            btnKenoPlay.click(function (event) {
                //_gaq.push(['_trackEvent', 'KenoDrawings', 'Play-Pause', step]); // GA event tracking
                if ($('.btnKenoPlay.allowPause').length && paused == false) {
                    //$('#kenoPlayer *').pause();
                    paused = true;
                    btnKenoPlay.css('background-position', '0 -83px');
                    clearTimeout(counter);

                } else if (paused == true) {
                    //$('#kenoPlayer *').resume();
                    paused = false;
                    btnKenoPlay.css('background-position', '0 9px');
                    if (step == 'boosterReveal') {
                        boosterRemove();
                    } else if (step == 'results') {
                        clearStartNext();
                    }
                }
                event.preventDefault();
            });
            // 5.1 - PREVIOUS DRAWING ////////////////////////////////////////////////////////////////////
            btnKenoPrev.click(function (e) {
                e.preventDefault(); if (drawCycle > 0) {
                    goPrev();
                }
            });
            // 5.2 - DECREASE CYCLE BY 2 //////////////////////////////////////////////////////////////
            function goPrev() {
                //_gaq.push(['_trackEvent', 'KenoDrawings', 'Skip', 'Previous']); // GA event tracking
                prevNextSkip = true;
                drawingNumber--;
                drawingNumber--;
                drawCycle--;
                drawCycle--;
                if (step == 'results') {
                    clearStartNext();
                    return false;
                }
                winBallCount = 0;
                skipToEnd();
            }
            // 5.3 - NEXT DRAWING ////////////////////////////////////////////////////////////////////
            btnKenoNext.click(function (e) {
                e.preventDefault();
                //_gaq.push(['_trackEvent', 'KenoDrawings', 'Skip', 'Next']); // GA event tracking
                if (drawRepeat > (drawCycle + 1)) {
                    prevNextSkip = true;
                    if (step == 'results') {
                        clearStartNext();
                        return false;
                    }
                    skipToEnd();
                }
            });
        },
        // 6.0 - CONTROL BAR FUNCTIONS /////////////////////////////////////////////////////////////////
        // 6.1 - PLAY-PAUSE TOGGLE ACTIVE STATUS
        _kenoPlayButton(playStatus) {
            if (playStatus === 'on') {
                $('.btnKenoPlay').css('opacity', '1.0').addClass('allowPause');
            } else if (playStatus === 'off') {
                $('.btnKenoPlay').css('opacity', '0.5').removeClass('allowPause');
            }
        },
        // 6.2 - ACTIVATE-DEACTIVATE BUTTONS //////////////////////////////////////////////////////
        _kenoButtonToggle(button, playStatus) {
            //alert('button toggle called');
            if (playStatus === 'on') {
                $(button).css({ 'opacity': '1', 'cursor': 'pointer' });
            } else if (playStatus === 'off') {
                $(button).css({ 'opacity': '0.5', 'cursor': 'default' });
            }
        },
        ////////////////////////////////////////////////////////////////////////////////////////////////
    }
};


</script>

<style lang="scss" scoped>
.button {
    &.btn-tertiary {
        background-color: #5161ac;
        margin: 0 auto;
    }
}

@media (max-width: 499px){
    .kenoWrapper{
        transform: scale(.5) translateX(-185px) translateY(200px);
    }
}

@media (min-width: 500px) and (max-width: 640px){
    .kenoWrapper{
        transform: scale(.7) translateX(-120px) translateY(90px);
    }
}
@media (min-width: 641px) and (max-width: 719px){
    .kenoWrapper{
        transform: scale(.80) translateX(-10px) translateY(50px);
    }
}
@media (min-width: 720px){
    .kenoWrapper{
        scale:1;
    }
}
</style>